import { pushToDataLayer } from '../dataLayer'

const getRoutePathName = {
  '/': 'catalogo-de-produtos',
  '/:id/edit': 'edicao-de-produto',
  '/editar/:id': 'edicao-de-produto',
  '/:id/new': 'cadastrar-produto-equivalente',
  '/import': 'importar-planilha',
  '/import/:id/failure': 'falhas-de-importacao',
  '/import/history': 'historico-de-importacoes',
  '/new': 'cadastrar-novo-produto',
  '/novo-produto': 'cadastrar-novo-produto',
  '/search': 'cadastrar-produto-pesquisar',
}

export type TKindPathName = keyof typeof getRoutePathName

const pageViewEvent = (pathname: TKindPathName): void => {
  const label = getRoutePathName[pathname]

  pushToDataLayer({
    eventAction: 'view',
    eventCategory: 'produto',
    eventLabel: `${label}`,
    eventNonInteraction: '1',
  })
}

export { pageViewEvent }
